import "react-toastify/dist/ReactToastify.css";
import PrivateRoutes from './private.routes';
import PublicRoutes from './public.routes';
import { useAuth } from '../Hooks/useAuth';

const AppRoutes: React.FC = () => {
    const { isAuthenticated } = useAuth();

    return (
        <>
            {isAuthenticated ? <PrivateRoutes /> : <PublicRoutes />}
        </>
    );
};

export default AppRoutes;